export default {
    methods: {
        getBase64File(file) {
            let self = this
            var reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = function() {
                self.data = reader.result
            }
            reader.onerror = function(error) {
                console.log('Error: ', error)
            }
        },
        getBase64FromFile (file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)

                reader.onload = () => {
                    let encoded = reader.result

                    if ((encoded.length % 4) > 0) {
                        encoded += '='.repeat(4 - (encoded.length % 4))
                    }
                    resolve(encoded)
                }

                reader.onerror = error => reject(error)
            })
        },
        getBase64Server(response) {
            let base64 = btoa(
                new Uint8Array(response.data.data).reduce(
                    (data, byte) => data + String.fromCharCode(byte),
                    ''
                )
            )
            return 'data:image/gif;base64,' + base64
        },
    },
}
